// REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

// LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// LOGIN FROM LOCAL
export const POST_LOGIN = "/account/login";

// REGISTER FROM LOCAL
export const POST_REGISTER = "/account/register";

// LOGOUT FROM LOCAL
export const GET_LOGOUT = "/account/logout";

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Chat
export const GET_CHAT = "/get-chat";
export const ADD_CHAT = "/add-chat";
export const DELETE_CHAT = "/delete-chat";
export const BOOKMARK_CHAT = "/delete-chat";
export const GET_CONVERSATION = "/Communication/conversation";
export const SEND_MESSAGE = "/Communication";
export const UPDATE_MESSAGE = "/Communication/message";
export const CREATE_NOTE_ACTIVITIES =
  "/Communication/conversation/activity-notes";

// Contact
export const GET_CONTACT = "/contact";
export const GET_COUNT = "/contact/count";
export const SEARCH_BY_KEYWORD = "/contact/search";
export const ADD_CONTACT = "/contact";
export const BULK_IMPORT_CONTACTS = "/contact/bulk-import";
export const GET_DETAIL_CONTACT = "/contact";
export const GET_SALE_REP = "/contact/sale-rep";
export const GET_ALL_LIST = "/contact/get-list";

// Events
export const GET_EVENT = "/event";
export const ADD_EVENT = "/event";
export const GET_DETAIL_EVENT = "/event";
export const GET_USER_EVENTS = "/event/user-events";
export const CHECK_AVAILABLE = "/event/check-available";
export const UPDATE_EVENT = "/edit-event";
export const DELETE_EVENT = "/delete-event";

// Calendars
export const GET_USER_CALENDAR = "/calendar/user-calendar";

// Working Hour
export const ADD_WORKING_HOUR = "/working-hour";
export const GET_WORKING_HOUR = "/working-hour";
export const GET_BREAKING_TIME = "/working-hour/breaking-time";

// Workflow
export const ADD_WORKFLOW = "/workflows/workflow-definitions";
export const GET_WORKFLOW = "/workflows";
export const DELETE_WORKFLOW = "/workflows";
export const EXECUTE_WORKFLOW = "/workflows/execute";
export const ACTIVITIES = "/workflows/activities";

// MailBox
export const GET_MAIL = "/get-mail";
export const DELETE_MAIL = "/delete-mail";
export const UNREAD_MAIL = "/unread-mail";
export const STARED_MAIL = "/stared-mail";
export const TRASH_MAIL = "/trash-mail";

// Category
export const GET_CATEGORY = "/get-category";
export const DELETE_CATEGORY = "/delete-category";

// Orders
export const GET_ORDERS = "/get-orders";
export const ADD_ORDERS = "/add-orders";
export const UPDATE_ORDERS = "/edit-orders";
export const DELETE_ORDERS = "/delete-orders";

// Sellers
export const GET_SELLERS = "/get-sellers";
export const ADD_SELLERS = "/add-sellers";
export const UPDATE_SELLERS = "/edit-sellers";
export const DELETE_SELLERS = "/delete-sellers";

// Products
// List View
export const GET_PRODUCT_LIST = "/get-product-list";
export const ADD_PRODUCT_LIST = "/add-product-list";
export const UPDATE_PRODUCT_LIST = "/edit-product-list";
export const DELETE_PRODUCT_LIST = "/delete-product-list";

// Grid View
export const GET_PRODUCT_GRID = "/get-product-grid";
export const ADD_PRODUCT_GRID = "/add-product-grid";
export const UPDATE_PRODUCT_GRID = "/edit-product-grid";
export const DELETE_PRODUCT_GRID = "/delete-product-grid";

// Overview
export const GET_REVIEW = "/get-review";
export const ADD_REVIEW = "/add-review";
export const UPDATE_REVIEW = "/edit-review";
export const DELETE_REVIEW = "/delete-review";

// HR Management
// Employee List
export const GET_EMPLOYEE = "/get-employee";
export const ADD_EMPLOYEE = "/add-employee";
export const UPDATE_EMPLOYEE = "/edit-employee";
export const DELETE_EMPLOYEE = "/delete-employee";

// Holidays
export const GET_HOLIDAYS = "/get-holidays";
export const ADD_HOLIDAYS = "/add-holidays";
export const UPDATE_HOLIDAYS = "/edit-holidays";
export const DELETE_HOLIDAYS = "/delete-holidays";

// Leaves Manage Employee
export const GET_LEAVE_MANAGE_EMPLOYEE = "/get-leave-manage-employee";

// Leave Manage (HR)
export const GET_LEAVE_MANAGE_HR = "/get-leave-manage-hr";
export const ADD_LEAVE_MANAGE_HR = "/add-leave-manage-hr";
export const UPDATE_LEAVE_MANAGE_HR = "/edit-leave-manage-hr";
export const DELETE_LEAVE_MANAGE_HR = "/delete-leave-manage-hr";

// Attendance
// Attendance (HR)
export const GET_ATTENDANCE = "/get-attendance";

// Main Attendance
export const GET_MAIN_ATTENDANCE = "/get-main-attendance";

// Departments
export const GET_DEPARTMENTS = "/get-departments";
export const ADD_DEPARTMENTS = "/add-departments";
export const UPDATE_DEPARTMENTS = "/edit-departments";
export const DELETE_DEPARTMENTS = "/delete-departments";

// Sales
// Estimates
export const GET_ESTIMATES = "/get-estimates";
export const ADD_ESTIMATES = "/add-estimates";
export const UPDATE_ESTIMATES = "/edit-estimates";
export const DELETE_ESTIMATES = "/delete-estimates";

// Payments
export const GET_PAYMENTS = "/get-payments";

// Expenses
export const GET_EXPENSES = "/get-expenses";
export const ADD_EXPENSES = "/add-expenses";
export const UPDATE_EXPENSES = "/edit-expenses";
export const DELETE_EXPENSES = "/delete-expenses";

// Payroll
// Employee Salary
export const GET_EMPLOYEE_SALARY = "/get-employee-salary";
export const ADD_EMPLOYEE_SALARY = "/add-employee-salary";
export const UPDATE_EMPLOYEE_SALARY = "/edit-employee-salary";
export const DELETE_EMPLOYEE_SALARY = "/delete-employee-salary";

// Notes
export const GET_NOTES = "/get-notes";
export const ADD_NOTES = "/add-notes";
export const UPDATE_NOTES = "/edit-notes";
export const DELETE_NOTES = "/delete-notes";

// Social
// Friends
export const GET_SOCIAL_FRIENDS = "/get-social-friends";

// Events
export const GET_SOCIAL_EVENTS = "/get-social-event";
export const ADD_SOCIAL_EVENTS = "/add-social-event";
export const UPDATE_SOCIAL_EVENTS = "/edit-social-event";
export const DELETE_SOCIAL_EVENTS = "/delete-social-event";

// invoice
export const GET_INVOICE_LIST = "/get-invoice-list";

// Users
export const GET_USER = "/identity/users";
export const GET_USER_DETAIL = "/identity/users";
export const ADD_USER = "/identity/users";
export const UPDATE_USER = "/identity/users";
export const DELETE_USER = "/identity/users";
export const GET_USER_BY_USERNAME = "/identity/users/by-username";
export const GET_USER_BY_EMAIL = "/identity/users/by-email";
export const GET_USER_ROLE = "/identity/users";

// Direct Message (internal 1:1 chat)
export const DIRECT_MESSAGE = "/Communication/direct-message";

// Roles
export const GET_ROLE = "/identity/roles";

// List View
export const GET_USER_LIST = "/get-userlist";
export const ADD_USER_LIST = "/add-userlist";
export const UPDATE_USER_LIST = "/edit-userlist";
export const DELETE_USER_LIST = "/delete-userlist";

// Jobs
export const SYNC_CONTACT_DATA =
  "/backgroundworker-drawing/trigger-getcontactsnimbus-worker";

// NimBus
export const GET_API_KEY = "/app/nimbus/api-key";

// Email Campaign
export const GENERATE_EMAIL_TEMPLATE = "/emailCampaign/generate-template";
export const GET_EMAIL_CAMPAIGN = "/emailCampaign";
export const GET_Question_Answer = "/emailCampaign/question-answer";
export const UPDATE_EMAIL_CAMPAIGN = "/emailCampaign";
export const SEND_EMAIL = "/Communication/email/bulk-send";
export const SEND_CAMPAIGN_MARKETING = "/emailCampaign/send-campaign-marketing";
export const CAMPAIGN_AGENT = "/CampaignAgent/get-response";
export const CAMPAIGN_CONVERSATIONS = "/CampaignAgent/campaign-conversations";

// Dashboard
export const GET_DASHBOARD_SUMMARY = "/dashboard/dashboard-summary";

// Knowledge
export const GET_KNOWLEDGE = "/knowledge";
export const GET_KNOWLEDGE_DETAIL = "/knowledge";
export const CREATE_KNOWLEDGE = "/knowledge";
export const UPDATE_KNOWLEDGE = "/knowledge";
export const DELETE_KNOWLEDGE = "/knowledge";
export const UPLOAD_FILE = "/knowledge/files/upload";
export const CRAWL_WEBSITE = "/knowledge/crawl-website";
export const INITIALIZE_KNOWLEDGE_BASE = "/knowledge/init";
export const GET_DOCUMENT = "/knowledge/documents";
export const SEARCH_RAG = "/Search";

// Grid View
export const GET_USER_GRID = "/get-usergrid";
export const ADD_USER_GRID = "/add-usergrid";
export const UPDATE_USER_GRID = "/edit-usergrid";
export const DELETE_USER_GRID = "/delete-usergrid";

// Settings
export const GENERAL_SETTINGS = "/settings";
